import BaseClient from './BaseClient';

class PhoneNumbersClient extends BaseClient {
    listPhoneNumbers(teamId, params) {
        const url = `/api/v3/teams/${teamId}/phone-numbers`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    countPhoneNumbers(teamId) {
        const url = `/api/v3/teams/${teamId}/phone-numbers/count`;
        return this.makeCoreApiRequest(url, 'get');
    }

    showPhoneNumber(teamId, phoneNumberId) {
        const url = `/api/v3/teams/${teamId}/phone-numbers/${phoneNumberId}`;
        return this.makeCoreApiRequest(url, 'get');
    }
}

export default new PhoneNumbersClient();
